<template>
  <div class="layout-container">
    <el-row>
      <HeadBar></HeadBar>
    </el-row>
    <el-row>
      <SubNav></SubNav>
    </el-row>
    <div class="content-page">
      <div class="content">
        <div class="container-fluid">
          <router-view ref="page-body"></router-view>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import HeadBar from '@/layouts/HeadBar.vue'
import SubNav from '@/layouts/SubNav.vue'
import Footer from '@/layouts/Footer.vue'

export default {
  name: 'layouts',
  components: {
    HeadBar,
    SubNav,
    Footer,
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
<style scoped></style>
